import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { StrictMode } from "react";
import { LanguageProvider } from "context/LanguageContext";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <StrictMode>
    <LanguageProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </LanguageProvider>
  </StrictMode>
);
